<template>
  <div class="min-w-0">
    <HolidayScheduleList v-bind="props" class="lg:hidden" @confirm-defaults="emit('confirm-defaults', $event)" @edit="emit('edit', $event)" />
    <HolidayScheduleTable v-bind="props" class="hidden lg:block" @confirm-defaults="emit('confirm-defaults', $event)" @edit="emit('edit', $event)" />
  </div>
</template>

<script setup>
import HolidayScheduleList from './HolidayScheduleList.vue'
import HolidayScheduleTable from './HolidayScheduleTable.vue'

const props = defineProps({
  holidays: { type: Array, required: true },
  savingIds: { type: Array, default: () => [] },
  showCompany: { type: Boolean, default: false },
  allowLockedEditing: { type: Boolean, default: false },
  rowIdKey: { type: String, default: 'holiday_id' },
})

const emit = defineEmits(['confirm-defaults', 'edit'])
</script>
